var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgToggleDisabled({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "19px",
    viewBox: "0 0 32 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "51C2EBA8-0487-47E4-A2A2-01238E2CAF0F") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Settings-and-Preferences",
    transform: "translate(-929.000000, -335.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Active-Toggle",
    transform: "translate(929.751326, 335.635471)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#67CA65",
    x: 0,
    y: 0,
    width: 30.8125,
    height: 18.0625,
    rx: 9.03125
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 21.8541461,
    cy: 9.03125,
    r: 7.97713026
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggleDisabled);
export default __webpack_public_path__ + "static/media/ToggleDisabled.75c4538693e8d1e2fb386ff2741b9391.svg";
export { ForwardRef as ReactComponent };